import {
  OrderList,
  OrderDetail,
  HKOrderDetail,
  HKStockDetail,
  OrderEdit
} from '~/views/Order';
import Layout from '~/layout/index.vue'

const OrderRoutes = {
  path: '/order',
  component: Layout,
  children: [
    {
      path: '',
      name: 'orderList',
      component: OrderList,
      meta: {
        title: '订单列表',
        isBack: false,
        isHeaderShow: true,
        showOrder:true
      },
    },
    {
      path: 'OrderEdit',
      name: 'OrderEdit',
      component: OrderEdit,
      meta: {
        title: '新增订单',
        isBack: true,
        isHeaderShow: true,
      },
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: OrderDetail,
      meta: {
        title: '进口订单详情',
        isBack: true,
        isHeaderShow: true
      },
    },
    {
      path: 'hkOrderDetail',
      name: 'hkOrderDetail',
      component: HKOrderDetail,
      meta: {
        title: '本港单详情',
        isBack: true,
        isHeaderShow: true
      },
    },
    {
      path: 'hkStockDetail',
      name: 'hkStockDetail',
      component: HKStockDetail,
      meta: {
        title: '出库单详情',
        isBack: true,
        isHeaderShow: true
      },
    }
  ]
}


export {
  OrderRoutes
}
